module.exports = __webpack_public_path__ + "img/why-fasilitas.be5dbbef.svg";